export default __webpack_public_path__ + "937ec881a81ec799d809dca64d6f3de6.png";